import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { CurrentLanguageContext } from "../../../Context/CurrentLanguageContext/CurrentLanguageContext";
import { Icon } from "../../Icon/Icon";
import "./LoginAppSelect.css";
import * as Cookies from "js-cookie";

export const LoginAppSelect = () => {
  const history = useHistory();
  const { data } = useQuery(getUserInformation);
  const { currentLanguage, handleChangeLanguage } = useContext(
    CurrentLanguageContext
  );
  const { t } = useTranslation();
  const hasApplicationRole = Cookies.get("access_level");

  useEffect(() => {
    if (
      data?.user?.prefferedLanguage &&
      data?.user?.prefferedLanguage !== currentLanguage &&
      data?.user?.prefferedLanguage !== undefined
    ) {
      handleChangeLanguage(data?.user?.prefferedLanguage, "automatic");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const workflowApps = data?.user?.roles?.workflow;
  const inventoryApps = data?.user?.roles?.inventory;

  return (
    <div className="LoginAppSelect">
      <div className="LoginAppSelect__title">
        <p className="LoginAppSelect__title-text">
          {t("loginForm.selectApplication")}
        </p>
      </div>
      {workflowApps?.length > 0 && (
        <LoginAppSelectItem
          key={knownApps[0].name}
          name={knownApps[0].name}
          icon={knownApps[0].icon}
          onClick={() => history.push("/login/apps/workflow")}
        />
      )}
      {inventoryApps?.length > 0 && (
        <LoginAppSelectItem
          key={knownApps[1].name}
          name={knownApps[1].name}
          icon={knownApps[1].icon}
          onClick={() => history.push("/login/apps/inventory")}
        />
      )}
      <LoginAppSelectItem
        key={"Account settings"}
        name={t("loginForm.accountSettings")}
        icon={"iconSSO"}
        onClick={() => {
          if (
            hasApplicationRole === "SUPERADMIN" ||
            hasApplicationRole === "DISTRIBUTOR"
          ) {
            history.push("/admin/profile");
          } else {
            history.push("/sso/profile");
          }
        }}
      />
    </div>
  );
};

export const LoginAppSelectItem = ({ name, icon, onClick = () => {} }) => {
  const { t } = useTranslation();
  return (
    <div className="LoginAppSelectItem" onClick={onClick}>
      <div className="LoginAppSelectItem__icon">
        <Icon name={icon} width={59} height={59} />
      </div>
      <div className="LoginAppSelectItem__text">{name}</div>
      <div className="LoginAppSelectItem__action">
        <div className="LoginAppSelectItem__action-text">
          {t("generic.select")}
        </div>
        <Icon name="iconDropdown" width={12} height={7} />
      </div>
    </div>
  );
};

const getUserInformation = gql`
  query {
    user {
      id
      email
      roles
      prefferedLanguage
    }
  }
`;

export const knownApps = [
  {
    name: "Workflow",
    icon: "iconWorkflow",
    goToUrl: process.env.REACT_APP_WORKFLOW_URL,
  },
  {
    name: "Inventory",
    icon: "iconInventory",
    goToUrl: process.env.REACT_APP_INVENTORY_URL,
  },
  {
    name: "Account settings",
    icon: "iconSSO",
    goToUrl: window.location.origin + "/sso/profile",
  },
];
